import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ShowUserFacade } from '../../../../../Facades/Intune/show-user.facade';
import { IntuneDevice } from '../../../../../Models/Intune/intune-device.model';
import { AvContentContainerComponent } from '../../../../Shared/Components/av-content-container/av-content-container.component';
import { AvTableCard } from '../../../../Shared/Components/av-table-card/av-table-card.component';
import {
  AvTableColumn,
  AvTableLinkCell,
  AvTableRow,
} from '../../../../Shared/Interfaces/av-table-card.interface';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { AvLoadingItemComponent } from '../../../../Shared/Components/av-loading-item/av-loading-item.component';

@Component({
  selector: 'app-devices',
  standalone: true,
  imports: [COMMON_IMPORTS, AvContentContainerComponent, AvTableCard, AvLoadingItemComponent],
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss'],
})
export class DevicesComponent {
  private readonly _facade = inject(ShowUserFacade);
  private readonly _router = inject(Router);
  private readonly _translate = inject(TranslateService);

  readonly isLoading = computed(() => this._facade.devicesStatus() === 'loading');

  private readonly userDevicesList = computed<IntuneDevice[]>(() => this._facade.devices());

  readonly deviceColumns: AvTableColumn[] = [
    { key: 'index', label: 'app.devices.table.columns.index', sortable: true },
    { key: 'deviceName', label: 'app.devices.table.columns.device_name', type: 'link', sortable: true },
    { key: 'operatingSystem', label: 'app.devices.table.columns.operating_system', sortable: true },
    { key: 'manufacturer', label: 'app.devices.table.columns.manufacturer', sortable: true },
    { key: 'model', label: 'app.devices.table.columns.model', sortable: true },
    { key: 'complianceState', label: 'app.devices.table.columns.compliance', sortable: true },
    { key: 'enrolledDateTime', label: 'app.devices.table.columns.enrolled_date', sortable: true },
    { key: 'lastSync', label: 'app.devices.table.columns.last_sync', sortable: true },
  ];

  readonly deviceRows = computed<AvTableRow[]>(() => {
    return this.userDevicesList().map((device, i) =>
      this.deviceToRow(device, i + 1)
    );
  });

  private deviceToRow(
    device: IntuneDevice,
    index: number,
  ): AvTableRow {
    const id = device.routeId();

    return {
      index,
      deviceName: <AvTableLinkCell>{
        text: device.displayDeviceName(),
        routerLink: ['/devices', id],
      },
      operatingSystem: device.displayOperatingSystem(),
      manufacturer: device.manufacturer,
      model: device.model,
      complianceState: device.displayCompliance(),
      enrolledDateTime: device.displayEnrolledDateTime(),
      lastSync: device.displayLastSync(),
    };
  }
}
